import { Card, ExtendedTableColumn, Table, Text, Tooltip } from '@lithos';
import { FC } from 'react';
import { FeatureForFCO, FeatureViewFCO, FeatureViewFCOFields } from '../../../core/types/fcoTypes';

interface FeatureViewFeaturesCardProps {
  featureView: FeatureViewFCO;
}

const FeatureViewFeaturesCard: FC<FeatureViewFeaturesCardProps> = ({ featureView }) => {
  const items = featureView[FeatureViewFCOFields.FEATURES];
  const canShowModelColumn = Object.keys(featureView[FeatureViewFCOFields.MODEL_MAP] ?? {}).length > 0;

  const modelColumn = canShowModelColumn
    ? [
        {
          name: 'Model',
          id: 'model',
          content: (feature: FeatureForFCO) => {
            return (
              <>
                <Tooltip
                  title={feature?.modelName}
                  content={''}
                  data-testid="model-tooltip-content"
                  trigger={<Text>{feature?.modelName ?? 'N/A'}</Text>}
                  placement="top"
                />
              </>
            );
          },
        },
      ]
    : [];
  const columns: ExtendedTableColumn<FeatureForFCO & { id: string }>[] = [
    {
      name: 'Name',
      id: 'name',
      content: (feature: FeatureForFCO) => {
        return <Text>{feature.name}</Text>;
      },
    },
    {
      name: 'Type',
      id: 'type',
      content: (feature: FeatureForFCO) => {
        return feature.type;
      },
    },
    ...[...modelColumn],
  ];

  return (
    <Card title={`Features (${featureView[FeatureViewFCOFields.FEATURES].length})`}>
      <Table items={items.map((item) => ({ ...item, id: item.name }))} columns={columns} />
    </Card>
  );
};

export default FeatureViewFeaturesCard;
